import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const UserProfile = () => {
  const [active, setActive] = useState(0);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* USER PROFILES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">User Profiles</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Profile Card</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-blue-500 rounded-full mx-auto mb-2 flex items-center justify-center text-white font-bold text-xl">JD</div>
              <h4 className="font-semibold text-slate-100 text-sm">John Doe</h4>
              <p className="text-xs text-slate-400">john@example.com</p>
              <button className="mt-3 px-3 py-1 bg-amber-600 text-white text-xs rounded">Edit Profile</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="text-center p-4">
  <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-blue-500 rounded-full mx-auto mb-2 flex items-center justify-center text-white font-bold">
    JD
  </div>
  <h3 className="font-semibold">John Doe</h3>
  <p className="text-slate-400">john@example.com</p>
  <button className="mt-3 bg-amber-600 text-white">Edit</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Profile with Status</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600">
              <div className="flex items-center gap-3 mb-3">
                <div className="relative">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-amber-600 rounded-full flex items-center justify-center text-white font-bold">SA</div>
                  <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-slate-950"></div>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-slate-100">Sarah Anderson</h4>
                  <p className="text-xs text-green-400">Online now</p>
                </div>
              </div>
              <button className="w-full px-2 py-1 bg-slate-700 text-slate-300 text-xs rounded">Message</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-3">
  <div className="relative">
    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-600 to-amber-600"></div>
    <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2"></div>
  </div>
  <div>
    <h4>Sarah Anderson</h4>
    <p className="text-green-400 text-sm">Online</p>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Profile with Stats</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600">
              <div className="text-center mb-4">
                <div className="w-16 h-16 bg-indigo-600 rounded-full mx-auto mb-2 flex items-center justify-center text-white font-bold text-xl">MJ</div>
                <h4 className="font-semibold text-slate-100">Mike Johnson</h4>
              </div>
              <div className="grid grid-cols-3 gap-2 text-center">
                <div><p className="text-sm font-bold text-amber-400">125</p><p className="text-xs text-slate-400">Posts</p></div>
                <div><p className="text-sm font-bold text-amber-400">2.5K</p><p className="text-xs text-slate-400">Followers</p></div>
                <div><p className="text-sm font-bold text-amber-400">340</p><p className="text-xs text-slate-400">Following</p></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="text-center">
  <div className="w-16 h-16 bg-gradient-to-br rounded-full mx-auto mb-2">
    JD
  </div>
  <h3>Name</h3>
  <div className="grid grid-cols-3 gap-2 mt-4 text-center">
    <div><p className="font-bold">125</p><p className="text-xs">Posts</p></div>
    <div><p className="font-bold">2.5K</p><p className="text-xs">Followers</p></div>
    <div><p className="font-bold">340</p><p className="text-xs">Following</p></div>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Compact Profile</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              {[{name: "Alex Chen", role: "Designer"}, {name: "Marie Dupont", role: "Developer"}].map((user, i) => (
                <div key={i} className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-slate-700 rounded-full"></div>
                    <div>
                      <p className="text-xs font-medium text-slate-200">{user.name}</p>
                      <p className="text-xs text-slate-400">{user.role}</p>
                    </div>
                  </div>
                  <button className="text-slate-400 hover:text-amber-400">+</button>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`{users.map(user => (
  <div key={user.id} className="flex items-center justify-between p-2">
    <div className="flex items-center gap-2">
      <img src={user.avatar} className="w-8 h-8 rounded-full" />
      <div>
        <p className="text-sm font-medium">{user.name}</p>
        <p className="text-xs text-slate-400">{user.role}</p>
      </div>
    </div>
    <button>+</button>
  </div>
))}`} />
          </div>
        </div>
      </div>

      {/* ADVANCED PROFILES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Profile with Cover</label>
            <div className="p-0 bg-slate-950 rounded border border-slate-600 overflow-hidden">
              <div className="h-20 bg-gradient-to-r from-amber-600 to-blue-600"></div>
              <div className="px-4 py-3">
                <div className="w-14 h-14 bg-slate-700 rounded-full -mt-9 mb-2 border-4 border-slate-950"></div>
                <h4 className="font-semibold text-slate-100">Profile User</h4>
                <p className="text-xs text-slate-400">Full Stack Developer</p>
                <div className="flex gap-2 mt-2">
                  <button className="flex-1 px-2 py-1 bg-amber-600 text-white text-xs rounded">Follow</button>
                  <button className="flex-1 px-2 py-1 bg-slate-700 text-slate-300 text-xs rounded">Message</button>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="overflow-hidden rounded">
  <div className="h-24 bg-gradient-to-r from-amber-600 to-blue-600"></div>
  <div className="p-4">
    <div className="w-16 h-16 bg-slate-700 rounded-full -mt-12 mb-2 border-4"></div>
    <h3>Name</h3>
    <p>Role</p>
    <button>Follow</button>
  </div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;


